export const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
